export const categories = [
  "All",
  "Fufu & Flour",
  "Palm Products",
  "Fresh Produce",
  "Pantry Products"
];

export const products = [
  // Fufu & Flour
  {
    id: "fufu-1",
    name: "Neat Fufu Cocoyam",
    category: "Fufu & Flour",
    packageSize: "12 x 680g",
    description: "A convenient cocoyam-based fufu flour for preparing traditional African meals at home, in restaurants or for catering.",
    suggestedUses: "Serve with soups and stews such as palm nut soup, groundnut soup, light soup or vegetable stew.",
    image: "https://adafrofood.com/files/local-image-small-52.png" // using praise plantain as placeholder for flour
  },
  {
    id: "fufu-2",
    name: "Neat Fufu Plantain",
    category: "Fufu & Flour",
    packageSize: "12 x 680g",
    description: "A convenient plantain-based fufu flour for preparing traditional African meals at home, in restaurants or for catering.",
    suggestedUses: "Serve with soups and stews such as palm nut soup, groundnut soup, light soup or vegetable stew.",
    image: "https://adafrofood.com/files/local-image-small-52.png"
  },
  {
    id: "fufu-3",
    name: "Praise Cocoyam Fufu Flour",
    category: "Fufu & Flour",
    packageSize: "12 x 680g",
    description: "Praise Cocoyam Fufu Flour is a convenient African staple product used for preparing smooth, satisfying fufu meals.",
    suggestedUses: "Serve with soups and stews such as palm nut soup, groundnut soup, light soup or vegetable stew.",
    image: "https://adafrofood.com/files/local-image-small-52.png"
  },
  {
    id: "fufu-4",
    name: "Praise Plantain Fufu Flour",
    category: "Fufu & Flour",
    packageSize: "12 x 680g",
    description: "Praise Plantain Fufu Flour is a convenient African staple product used for preparing smooth, satisfying fufu meals. It is suitable for home kitchens, restaurants, African food shops and wholesale supply.",
    suggestedUses: "Serve with soups and stews such as palm nut soup, groundnut soup, light soup or vegetable stew.",
    image: "https://adafrofood.com/files/local-image-small-52.png"
  },
  {
    id: "fufu-5",
    name: "Champions Gari White",
    category: "Fufu & Flour",
    packageSize: "2kg",
    description: "Premium white gari made from processed cassava. A versatile staple for everyday meals.",
    suggestedUses: "Can be soaked for drinking, mixed with hot water for eba, or used as a side dish.",
    image: "https://adafrofood.com/files/local-image-small-397.png"
  },
  {
    id: "fufu-6",
    name: "Champions Cassava Dough",
    category: "Fufu & Flour",
    packageSize: "Various sizes",
    description: "Authentic fermented cassava dough, perfect for preparing traditional banku.",
    suggestedUses: "Mix with corn dough to prepare banku, served with grilled tilapia and hot pepper.",
    image: "https://adafrofood.com/files/local-image-small-397.png" // placeholder using gari image
  },

  // Palm Products
  {
    id: "palm-1",
    name: "Nkulemu Palm Soup",
    category: "Palm Products",
    packageSize: "12 x 800g",
    description: "Rich, concentrated palm nut soup base for authentic West African cooking.",
    suggestedUses: "Use as a base for palm nut soup with meat, fish, and traditional spices.",
    image: "https://adafrofood.com/files/local-image-small-84.png" // using palm oil as placeholder
  },
  {
    id: "palm-2",
    name: "Ghana Fresh Palmnut Cream",
    category: "Palm Products",
    packageSize: "12 x 800g",
    description: "High-quality palmnut cream, providing the authentic taste of fresh palm nuts.",
    suggestedUses: "Ideal for making quick and delicious palm nut soup at home or in restaurants.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },
  {
    id: "palm-3",
    name: "Praise Palm Cream",
    category: "Palm Products",
    packageSize: "12 x 800g",
    description: "Smooth and rich palm cream for traditional soups and stews.",
    suggestedUses: "Perfect base for traditional Ghanaian palm nut soup.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },
  {
    id: "palm-4",
    name: "Praise Palm Oil Regular",
    category: "Palm Products",
    packageSize: "1L",
    description: "A classic palm oil product for traditional West African cooking, stews and sauces.",
    suggestedUses: "Use for frying, making stews, or adding rich color and flavor to dishes.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },
  {
    id: "palm-5",
    name: "Praise Palm Oil Zomi",
    category: "Palm Products",
    packageSize: "1L",
    description: "Premium spiced palm oil (Zomi), known for its distinct roasted flavor and rich aroma.",
    suggestedUses: "Excellent for final seasoning of beans, yam, or traditional stews.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },
  {
    id: "palm-6",
    name: "Praise Palm Oil Regular",
    category: "Palm Products",
    packageSize: "2L",
    description: "A classic palm oil product for traditional West African cooking, stews and sauces in a larger family size.",
    suggestedUses: "Use for frying, making stews, or adding rich color and flavor to dishes.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },
  {
    id: "palm-7",
    name: "Praise Palm Oil Zomi",
    category: "Palm Products",
    packageSize: "2L",
    description: "Premium spiced palm oil (Zomi) in a larger value size.",
    suggestedUses: "Excellent for final seasoning of beans, yam, or traditional stews.",
    image: "https://adafrofood.com/files/local-image-small-84.png"
  },

  // Fresh Produce
  {
    id: "fresh-1",
    name: "Fresh Yam Box",
    category: "Fresh Produce",
    packageSize: "Wholesale Box",
    description: "Premium quality fresh African yams. Staple root vegetable for numerous traditional dishes.",
    suggestedUses: "Can be boiled, fried, roasted, or pounded for traditional meals.",
    image: "https://adafrofood.com/files/local-image-small-497.jpg"
  },
  {
    id: "fresh-2",
    name: "Fresh Green Plantain Box",
    category: "Fresh Produce",
    packageSize: "Wholesale Box",
    description: "Fresh green plantains suitable for frying, boiling, roasting or preparing traditional dishes.",
    suggestedUses: "Ideal for making plantain chips, boiling to serve with stews, or roasting.",
    image: "https://adafrofood.com/files/local-image-small-496.png"
  },
  {
    id: "fresh-3",
    name: "Garden Eggs Fresh Box",
    category: "Fresh Produce",
    packageSize: "Wholesale Box",
    description: "Fresh African garden eggs, essential for authentic stews and sauces.",
    suggestedUses: "Perfect for preparing traditional garden egg stew to serve with boiled yam or plantain.",
    image: "https://adafrofood.com/files/local-image-small-496.png" // placeholder
  },

  // Pantry Products
  {
    id: "pantry-1",
    name: "Peanut Butter",
    category: "Pantry Products",
    packageSize: "12 x 400g",
    description: "Smooth, rich peanut butter made from high-quality roasted peanuts.",
    suggestedUses: "Essential for making authentic Ghanaian groundnut soup or for spreading.",
    image: "https://adafrofood.com/files/local-image-small-380.png"
  },
  {
    id: "pantry-2",
    name: "GoldCoast Organic Cocoa Powder",
    category: "Pantry Products",
    packageSize: "12 x 400g",
    description: "Rich, unsweetened cocoa powder sourced from premium cocoa beans.",
    suggestedUses: "Ideal for baking, hot beverages, or traditional breakfast porridge.",
    image: "https://adafrofood.com/files/local-image-small-380.png" // placeholder
  },
  {
    id: "pantry-3",
    name: "Winnies Hausa Koko",
    category: "Pantry Products",
    packageSize: "12 x 400g",
    description: "Spicy millet porridge mix, a traditional and popular breakfast staple.",
    suggestedUses: "Prepare with hot water and serve with milk, sugar, and koose (bean cakes).",
    image: "https://adafrofood.com/files/local-image-small-380.png" // placeholder
  },
  {
    id: "pantry-4",
    name: "Dry Roasted Unsalted Cashews",
    category: "Pantry Products",
    packageSize: "Various sizes",
    description: "Premium dry roasted cashews. A healthy and satisfying snack.",
    suggestedUses: "Enjoy as a snack, use in baking, or add to salads and savory dishes.",
    image: "https://adafrofood.com/files/local-image-small-167.png"
  }
];